import Vue from "vue"
import { eventBus } from '@/main'
import axios from '@axios'
import store from '../store'
import ToastContent from '@core/components/toastification/ToastificationContent.vue'
import trans from '@/libs/i18n'

class SocketClient {
  constructor() {}
  connect() {

    axios.get('wsGetToken').then(res => {
      const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

      // const ws = new WebSocket(`ws://${window.location.hostname}:${process.env.VUE_APP_WS_PORT}?token=${res.data.ws_token}`)
      const ws = new WebSocket(`${protocol}://${window.location.hostname}/ws?token=${res.data.ws_token}`)
      ws.onclose =  (event)  => console.log('close')
      ws.onopen =  (event) => store.dispatch('ws/set', ws).then(r => {}).catch(e => console.error('cant set websocket'))

      ws.onmessage = (msg) => {
        let message = JSON.parse(msg.data)

        if (message.type === 'notification' &&  store.getters['auth/getAllowNotifications']==true  ) {
          //if( !document.hidden){console.log(' active')}else{console.log('not active')}
          if( !document.hidden){
           // console.log(' active')
            Vue.$toast({
              component: ToastContent,
              props: {
                title: `${message.device}`,
                icon: message.event,
                text: `${trans.t(message.event)}` + ' ' + `${message.geofence ?? ''}`,
                time: message.time
              },
            });
          }

      }
        else
        {
          eventBus.$emit(message.type, message)
        }
      }

      }).catch(error => console.log(error))
  }
}

export default new SocketClient();
